import {
    createTableColumn,
    DataGrid,
    DataGridBody,
    DataGridCell,
    DataGridHeader,
    DataGridHeaderCell,
    DataGridRow
} from "@fluentui/react-components";
import {Link, useOutletContext, useParams} from "react-router-dom";
import {Button, ButtonGroup, FormControlLabel, Typography} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../../Services/AuthContext";
import {Edit, Delete, Add, ContactPage, Download} from "@mui/icons-material";
import AddAllowed from "../../Panel/Allowed/AddAllowed";
import AddGuardian from "../../Panel/Allowed/AddGuardian";
import EditAllowed from "../../Panel/Allowed/EditAllowed";
import EditGuardian from "../../Panel/Allowed/EditGuardian";
import Switch from "@mui/material/Switch";
import AddAgreementDocument from "../../Panel/Children/AddAgreementDocument";

function ChildrenAgreement() {

    const {children} = useOutletContext();
    const params = useParams();
    const [user] = useContext(AuthContext);
    const [allowed, setAllowed] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [addAgreementFile, setAddAgreementFile] = useState(false);

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchData() {
            await fetch(`/api/children/${children}/agreement/${params.id}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setAllowed(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [children, refresh]);

    function _save(id, value) {
        const target = value ? 0 : 1;
        fetch(`/api/children/${children}/agreement/${id}/${target}`, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(() => {
                setRefresh(r => ++r);
            })
            .catch(err => {
                console.log(err)
            })
    }

    function _saveAll() {
        fetch(`/api/children/${children}/agreement/all/${params.id}`, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(() => {
                setRefresh(r => ++r);
            })
            .catch(err => {
                console.log(err)
            })
    }


    const columns = [
        createTableColumn ({
            columnId: "agreement",
            compare: (a, b) => {
                return a.agreement.localeCompare(b.agreement);
            },
            renderHeaderCell: () => {
                return "Klauzula";
            },
            renderCell: (item) => {
                let addTxt = '';
                if (item.file) addTxt = ', wymagany plik';
                if (item.required) return <div style={{justifyItems: 'space-aside'}}><div>{item.agreement}</div><div><span style={{color: 'red'}}>*Zgoda obowiązkowa{addTxt}</span></div></div>
                return item.agreement
            }
        }),
        createTableColumn ({
            columnId: "more",
            renderHeaderCell: () => {
                return <Button variant={'contained'} color={'info'} onClick={() => _saveAll()}>Akceptuj wszystkie</Button>;
            },
            renderCell: (item) => {
                if (item.file && !item.value) {
                    return <FormControlLabel control={<Switch onChange={() => setAddAgreementFile({children: children, sid: item.id})} checked={item.value} />} label={item.value ? 'Wyrażam zgodę' : 'Nie wyrażam zgody'} />
                }
                let filename = '';
                if (item.filename !== null) {
                    filename = <Button target={'_blank'} href={`/api/children/agreement/${item.id}/file?auth=${user.token}`} variant={'contained'} color={'info'}><Download /></Button>
                }
                return <span><FormControlLabel control={<Switch onChange={() => _save(item.id, item.value)} checked={item.value} />} label={item.value ? 'Wyrażam zgodę' : 'Nie wyrażam zgody'} />{filename}</span>
            }
        }),
    ];

    return (
        <>
        <DataGrid
            items={allowed}
            columns={columns}
            sortable
            getRowId={(item) => item.id}
            focusMode="composite"
            style={{flexGrow: 1, maxWidth: '60vw'}}
        >
            <DataGridHeader>
                <DataGridRow>
                    {({renderHeaderCell}) => (
                        <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                    )}
                </DataGridRow>
            </DataGridHeader>
            <DataGridBody>
                {({item, rowId}) => (
                    <DataGridRow key={rowId}>
                        {({renderCell}) => (
                            <DataGridCell>{renderCell(item)}</DataGridCell>
                        )}
                    </DataGridRow>
                )}
            </DataGridBody>
        </DataGrid>
            <AddAgreementDocument add={addAgreementFile} onSuccess={() => setRefresh(r => ++r)} dismiss={() => setAddAgreementFile(false)} />
        </>
    );
}

export default ChildrenAgreement;